import React, { PropsWithChildren } from 'react'
import Monitor from './Monitor.styled'
import TextContainer from './TextContainer.styled'


type Props = PropsWithChildren<{  
}>



const CRTScreen: React.FC<Props> = ({ children }) => {
    return (
      <Monitor>
        <TextContainer>
          {children}
        </TextContainer>
      </Monitor>
    ) 
}

export default CRTScreen

